import * as Yup from "yup";

import checkout from "./forms";
const {
  formField: {
    codigoPromocional,
    dataInicio,
    validade,
    qtdCupom,
    disponivel,
    tipoPorcentagem,
    valorCupom,
    eventoId,
    colorField,
  },
} = checkout;

const baseValidate = {
  [codigoPromocional.name]: Yup.string().required(codigoPromocional.errorMsg),
  [dataInicio.name]: Yup.string().required(dataInicio.errorMsg),
  [validade.name]: Yup.string().required(validade.errorMsg),
  [qtdCupom.name]: Yup.string().required(qtdCupom.errorMsg),
  [disponivel.name]: Yup.string().required(disponivel.errorMsg),
  [tipoPorcentagem.name]: Yup.string().required(tipoPorcentagem.errorMsg),
  [valorCupom.name]: Yup.string().required(valorCupom.errorMsg),
  [eventoId.name]: Yup.mixed()
    .test(
      "evento-required",
      eventoId.errorMsg,
      (val) =>
        val != null &&
        (typeof val === "number" || (typeof val === "object" && val !== null && "id" in val))
    )
    .required(eventoId.errorMsg),
  [colorField.name]: Yup.string().required(colorField.errorMsg),
};

const validationsEdit = Yup.object().shape({
  ...baseValidate,
});

const validationsCreate = Yup.object().shape({
  ...baseValidate,
});

export { validationsEdit, validationsCreate };
